import { addMinutes, subMinutes } from 'date-fns';
import isSimpleDate from './isSimpleDate';

/**
 * If a string ends with T00:00:00Z, we can asusme that the provided time is just
 * "dummy" data, and we only should be interested in the date portion. To adjust
 * these dates to the timezone, the offset must be added.
 *
 * @param source - The source string to check
 */
function hasDummyTime(source: string): boolean {
  return source.endsWith('T00:00:00Z');
}

/**
 * This method will take a date string and try to offset it by the required amount
 * based on the timezone, so that consumer applications don't show discrepancies when
 * displaying dates in different timezones as the ones from the server.
 *
 * The T00:00:00Z is a special case where the "time" portion of the date must be ignored.
 *
 * @param source - The string to adjust
 */
export default function adjustForTimeZone(source: string): Date {
  const dateObject = new Date(source);

  /**
   * There's a minute mismatch for years prior to 1915,
   * so instead we need to grab a reference to UTC offset from
   * a current date object
   */
  const timeZoneOffset = new Date().getTimezoneOffset();

  if (hasDummyTime(source)) {
    return addMinutes(dateObject, timeZoneOffset);
  }
  if (!isSimpleDate(source)) {
    return subMinutes(dateObject, timeZoneOffset);
  }
  return dateObject;
}
